import React from 'react';
import { motion } from 'framer-motion';

const HighlightsSection = () => {
  const highlights = [
    {
      title: "夢幻牛奶海",
      desc: "全世界最神奇的海底火山活動，渲染出如同牛奶般的夢幻漸層海域。",
      image: "https://images.unsplash.com/photo-1559128010-7c1ad6e1b6a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    },
    {
      title: "與海豚共舞",
      desc: "每年七到十月，黑潮洋流帶來豐富生態，近距離觀賞海豚曼妙舞姿。",
      // 這裡換成了更生動的海豚躍動圖片
      image: "https://images.unsplash.com/photo-1518467166778-b88f373ffec7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    },
    {
      title: "神秘龜山島",
      desc: "走訪戰地遺跡、環繞龜尾湖，探索這座太平洋上的知性之島。",
      image: "https://images.unsplash.com/photo-1505228395891-9a51e7e86bf6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    }
  ];

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">必訪亮點</h2>
          <div className="w-24 h-1 bg-blue-500 mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {highlights.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="group rounded-2xl overflow-hidden bg-white shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={item.image} 
                  alt={item.title} 
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
                {/* 這是您提到的 Overlay Div，它能確保文字在圖片上清晰可見 */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <h3 className="absolute bottom-6 left-6 text-2xl font-bold text-white tracking-wide">{item.title}</h3>
              </div>
              <div className="p-6">
                <p className="text-slate-600 leading-relaxed">{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;